// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"dc2bc3dc","325":"2c775c92","483":"733ae90b"}[chunkId] + ".css";
};